import React from 'react';
import { FormattedMessage } from 'react-intl';
import TextInput from '../../components/TextInput';
import CountrySwitcher from '../../components/CountrySwitcher';
import PhoneNumberInput from '../../components/PhoneNumberInput';
import { formMessages as messages } from '../../defineMessages';

const recipientFields = {
  Giftcard: {
    Physical: [
      {
        label: 'fullName',
        name: 'recipientName',
        component: TextInput,
        type: 'text',
        required: true,
        responsive: {
          xs: 24,
        },
      },
      {
        label: 'attention',
        name: 'attention',
        component: TextInput,
        type: 'text',
        required: false,
        responsive: {
          xs: 24,
        },
      },
      {
        label: 'address',
        name: 'line1',
        placeholder: 'line1',
        component: TextInput,
        type: 'text',
        required: true,
        responsive: {
          xs: 24,
        },
      },
      {
        label: 'address',
        showLabel: false,
        name: 'line2',
        placeholder: 'line2',
        component: TextInput,
        type: 'text',
        required: false,
        responsive: {
          xs: 24,
        },
      },
      {
        label: 'postCode',
        name: 'postCode',
        component: TextInput,
        type: 'text',
        required: true,
        responsive: {
          xs: 24,
          md: 12,
        },
      },
      {
        label: 'city',
        name: 'city',
        component: TextInput,
        type: 'text',
        required: true,
        responsive: {
          xs: 24,
          md: 12,
        },
      },
      {
        label: 'email',
        name: 'recipientEmail',
        component: TextInput,
        type: 'email',
        required: false,
        responsive: {
          xs: 24,
        },
      },
      {
        label: 'phoneNumber',
        name: 'recipientPhone',
        placeholder: '',
        component: PhoneNumberInput,
        type: 'tel',
        required: false,
        responsive: {
          xs: 24,
        },
        invalidPhoneNumberErrorMessage: (
          <FormattedMessage {...messages.invalidPhoneNumber} />
        ),
      },
      {
        label: 'country',
        name: 'countryCode',
        component: CountrySwitcher,
        basic: true,
        showLabel: true,
        required: true,
        disabled: true,
        fluid: true,
        responsive: {
          xs: 24,
        },
      },
    ],
    Email: [
      {
        label: 'fullName',
        name: 'recipientName',
        component: TextInput,
        type: 'text',
        required: true,
        responsive: {
          xs: 24,
        },
      },
      {
        label: 'email',
        name: 'recipientEmail',
        component: TextInput,
        type: 'email',
        required: true,
        responsive: {
          xs: 24,
        },
      },
      {
        label: 'emailRepeat',
        name: 'recipientEmailRepeat',
        component: TextInput,
        type: 'email',
        required: true,
        responsive: {
          xs: 24,
        },
      },
    ],
    Sms: [
      {
        label: 'fullName',
        name: 'recipientName',
        component: TextInput,
        type: 'text',
        required: true,
        responsive: {
          xs: 24,
        },
      },
      {
        label: 'phoneNumber',
        name: 'recipientPhone',
        placeholder: '',
        component: PhoneNumberInput,
        type: 'tel',
        required: true,
        responsive: {
          xs: 24,
        },
        invalidPhoneNumberErrorMessage: (
          <FormattedMessage {...messages.invalidPhoneNumber} />
        ),
      },
      {
        label: 'phoneNumberRepeat',
        name: 'recipientPhoneRepeat',
        placeholder: '',
        component: PhoneNumberInput,
        type: 'tel',
        required: true,
        responsive: {
          xs: 24,
        },
        invalidPhoneNumberErrorMessage: (
          <FormattedMessage {...messages.invalidPhoneNumber} />
        ),
      },
    ],
    CsvByEmail: [
      {
        label: 'fullName',
        name: 'recipientName',
        component: TextInput,
        type: 'text',
        required: true,
        responsive: {
          xs: 24,
        },
      },
      {
        label: 'email',
        name: 'recipientEmail',
        component: TextInput,
        type: 'email',
        required: true,
        responsive: {
          xs: 24,
        },
      },
      {
        label: 'emailRepeat',
        name: 'recipientEmailRepeat',
        component: TextInput,
        type: 'email',
        required: true,
        responsive: {
          xs: 24,
        },
      },
    ],
  },
  PhysicalProduct: {
    Physical: [
      {
        label: 'fullName',
        name: 'recipientName',
        component: TextInput,
        type: 'text',
        required: true,
        responsive: {
          xs: 24,
        },
      },
      {
        label: 'postCode',
        name: 'postCode',
        component: TextInput,
        type: 'text',
        required: true,
        responsive: {
          xs: 24,
        },
      },
      {
        label: 'email',
        name: 'recipientEmail',
        component: TextInput,
        type: 'email',
        required: false,
        responsive: {
          xs: 24,
        },
      },
      {
        label: 'phoneNumber',
        name: 'recipientPhone',
        placeholder: '',
        component: PhoneNumberInput,
        type: 'tel',
        required: false,
        responsive: {
          xs: 24,
        },
        invalidPhoneNumberErrorMessage: (
          <FormattedMessage {...messages.invalidPhoneNumber} />
        ),
      },
    ],
  },
};

export default recipientFields;
